import type { ReactNode } from "react";
import { CommandItem } from "@/components/ui/command";
import type { CmdkItemComponent } from "./cmdk_registry.js";

interface CmdkItemProps {
  value: string;
  label: string;
  icon?: ReactNode;
  variant?: "default" | "destructive";
  onSelect: () => void;
  onClose: () => void;
}

export function CmdkItem({
  value,
  label,
  icon,
  variant,
  onSelect,
  onClose,
}: CmdkItemProps) {
  return (
    <CommandItem
      value={value}
      onSelect={() => {
        onSelect();
        onClose();
      }}
      className={variant === "destructive" ? "text-destructive" : ""}
    >
      {icon}
      {label}
    </CommandItem>
  );
}

/** Factory to create a cmdk item component from props */
export function createCmdkItem(
  props: Omit<CmdkItemProps, "onClose">,
): CmdkItemComponent {
  return function CmdkItemWrapper({ onClose }) {
    return <CmdkItem {...props} onClose={onClose} />;
  };
}
